import React, { VFC } from 'react';
import { FormikTextInput } from 'src/common/form/formik/text-input';

interface StepEditorContentConfigureTitleProps {
  fieldName: string;
  value: string;
  errorText?: string;
  onChange?: (value: string) => void;
}

export const StepEditorContentConfigureTitle: VFC<StepEditorContentConfigureTitleProps> = ({
  value,
  fieldName,
  errorText,
  onChange,
}) => {
  return (
    <div className='flex flex-col space-y-sm'>
      <div className='flex flex-col space-y-0.5 text-bedrock-black'>
        <h2 className='text-bedrock-p-strong'>Name this Step</h2>
        {errorText ? (
          <span className='text-bedrock-p-small text-bedrock-red'>{errorText}</span>
        ) : (
          <span className='text-bedrock-p-small'>This is the title recipients see when they view this</span>
        )}
      </div>
      <FormikTextInput
        name={fieldName}
        id={fieldName}
        onChange={onChange}
        type='text'
        required
        inputProps={{ value }}
      />
    </div>
  );
};
